<template>
  <div class="container">
    <div  class="map-list-item device row" @click="itemClicked" :title="this.entryData.name">
      <div class='state col-1'>
        <span class="helper"><div class='deviatIndicator' :style="{'background-color':statusColor}"></div></span>
        <b-icon scale="1.5" icon="display"></b-icon>
      </div>
      <div class='id'>{{ this.entryData.uniqueId }}</div> 
      <div class='name col'>{{ this.entryData.name }}</div>
    </div>
  
  </div>
</template>

<script>
export default {
  name: 'MapDeviceEntry',
  props: {
   entry: {type: Object}
  },
  data: function() {
    return {
      entryData: null,
      defaultData: {uniqueId:"-", name:""}
    }
  },
  created() {
    this.entryData = Object.assign(this.defaultData,this.entry);
    if(this.$route.query.displayId && this.$route.query.displayId == this.entryData.uniqueId) {
      this.$emit('click', this.$route.query.displayId);
      this.$route.query.displayId = undefined;
      this.itemClicked();
    }
    if(this.$route.query.uniqueId && this.$route.query.uniqueId == this.entryData.uniqueId) {
      this.$emit('click', this.$route.query.uniqueId);
      this.$route.query.uniqueId = undefined;
      this.itemClicked();
    }

    //debugger;
  },
  computed: {
    nimi: function() {
      try {
        return this.entryData.name.substring(0,25);
      }catch(err) {
        return "No name";
      }
    },
    statusColor : function(){
      var color = "#fff;"
      var device = this.entryData; 

      var status = this.getStatus(device);
      if(status == 'ONLINE') color = "rgb(40, 167, 69)";
      if(status == 'OFFLINE') color = "rgb(220, 53, 69)";
      if(status == 'UNKNOWN') color = "rgb(204, 204, 204)";
      
      /*
      if(device.type == 'SSE_DISPLAY') {
        if(device.onlineStatus == 'ONLINE') color = "rgb(40, 167, 69)";
        if(device.onlineStatus == 'OFFLINE') color = "rgb(220, 53, 69)";
        if(device.onlineStatus == 'UNKNOWN') color = "rgb(204, 204, 204)";
      }
      */
      
      return color;
    }
  },
  methods: {
    getStatus(item){
      var status = 'UNKNOWN';
      var device = item.device ? item.device : item;

      status = device.onlineStatus;
      /*
      if(device.type == 'INFOPOINT') {
        status = device.onlineStatus;
      }

      if(device.type == 'SSE_DISPLAY') {
        status = device.onlineStatus;
      }
      */

      return status;
    },

    itemClicked() {
      var devId = null;
      try {
        if(this.entryData.device != undefined) {
          devId = this.entryData.device.deviceId;
        } else {
          devId = this.entryData.deviceId;
        }
      }catch(err) {devId = null;}

      this.$emit('click', devId);
    }
  }
}
</script>

